(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('ValuationApiCallsController', ValuationApiCallsController);

    ValuationApiCallsController.$inject = ['$state', '$uibModal', 'ValuationApiCalls', 'ValuationApiClient', 'ParseLinks', 'AlertService', 'FileSaver', 'moment', 'pagingParams'];

    function ValuationApiCallsController ($state, $uibModal, ValuationApiCalls, ValuationApiClient, ParseLinks, AlertService, FileSaver, moment, pagingParams) {
        var vm = this;
        var defaultSort = 'requestedAt,desc';

        vm.pagingParams = pagingParams;
        vm.calls = null;
        vm.links = null;
        vm.totalItems = null;
        vm.fromDate = moment().subtract(1, 'month').toDate();
        vm.toDate = moment().toDate();
        // Coerce to a number so md-select matches the option ng-value (and the CRUD deep-link param).
        vm.valuationApiClientId = pagingParams.valuationApiClientId
            ? parseInt(pagingParams.valuationApiClientId, 10) : null;
        vm.successOnly = true; // show only successful calls by default
        vm.addressQuery = null; // free-text search over the queried address
        vm.requestType = null;  // billable bucket filter; null = all api calls
        vm.profile = null;      // endpoint/profile filter; null = all profiles
        vm.partners = [];
        // Billable request-type buckets for the filter dropdown (exact-match; '' = all api calls).
        vm.requestTypes = [
            { value: null, label: 'All API Calls' },
            { value: 'AVM', label: 'AVM Only' },
            { value: 'MARKET_RENT', label: 'Market Rent Only' },
            { value: 'AVM_AND_MARKET_RENT', label: 'AVM and Market Rent' }
        ];
        // Profile buckets for the filter dropdown (exact-match; null = all profiles).
        vm.profiles = [
            { value: null, label: 'All Profiles' },
            { value: 'ENRICHED', label: 'Enriched' },
            { value: 'ESSENTIALS', label: 'Essentials' },
            { value: 'ADJUSTED', label: 'Adjusted' }
        ];

        vm.loadData = loadData;
        vm.transition = transition;
        vm.applyFilters = applyFilters;
        vm.exportCsv = exportCsv;
        vm.viewRequest = viewRequest;
        vm.viewResponse = viewResponse;
        vm.viewUpstreamResponse = viewUpstreamResponse;
        vm.viewUpstreamRequest = viewUpstreamRequest;

        loadPartners();
        loadData();

        function buildParams() {
            return {
                page: vm.pagingParams.page - 1,
                size: 20,
                sort: getSort(),
                from: moment(vm.fromDate).startOf('day').toISOString(),
                to: moment(vm.toDate).endOf('day').toISOString(),
                valuationApiClientId: vm.valuationApiClientId || undefined,
                requestType: vm.requestType || undefined,
                profile: vm.profile || undefined,
                successOnly: vm.successOnly,
                addressQuery: vm.addressQuery || undefined
            };
        }

        function loadData() {
            return ValuationApiCalls.query(buildParams(), function(result, headers) {
                vm.calls = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            }, function(error) {
                AlertService.error(error.data && error.data.message);
            }).$promise;
        }

        function loadPartners() {
            // Populate the partner filter dropdown (first page is plenty for a select).
            ValuationApiClient.query({ page: 0, size: 1000, sort: 'partnerName,asc' }, function(result) {
                vm.partners = result;
            });
        }

        function getSort() {
            return vm.pagingParams.predicate + ',' + (vm.pagingParams.ascending ? 'asc' : 'desc');
        }

        function transition() {
            $state.go($state.$current, {
                page: vm.pagingParams.page === 1 ? null : vm.pagingParams.page,
                sort: getSort() === defaultSort ? null : getSort(),
                valuationApiClientId: vm.valuationApiClientId || null
            }, { notify: false }).then(loadData);
        }

        /**
         * Apply a filter change: jump back to the first page, then reload.
         */
        function applyFilters() {
            vm.pagingParams.page = 1;
            transition();
        }

        /**
         * Download a CSV of the current (filtered) result set.
         */
        function exportCsv() {
            var params = buildParams();
            delete params.page;
            delete params.size;
            delete params.sort;
            return ValuationApiCalls.export(params).$promise.then(function(response) {
                if (response && response.file) {
                    FileSaver.saveAs(response.file, 'valuation-api-calls.csv');
                }
            });
        }

        /**
         * Open a modal showing the incoming request JSON the partner sent us.
         */
        function viewRequest(call) {
            openDetail(call, 'request');
        }

        /**
         * Open a modal showing the outgoing response JSON we returned to the partner.
         */
        function viewResponse(call) {
            openDetail(call, 'response');
        }

        /**
         * Open a modal showing the raw upstream (Gnowise) response we received — internal tracing.
         */
        function viewUpstreamResponse(call) {
            openDetail(call, 'upstream');
        }

        /**
         * Open a modal showing the exact (transformed) payload we sent to Gnowise — internal tracing.
         */
        function viewUpstreamRequest(call) {
            openDetail(call, 'upstream-request');
        }

        function openDetail(call, mode) {
            $uibModal.open({
                templateUrl: 'app/admin/valuation-endpoint-calls/valuation-endpoint-call-detail-dialog.html',
                controller: 'ValuationApiCallDetailController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: ['ValuationApiCalls', function(ValuationApiCalls) {
                        if (mode === 'request') {
                            return ValuationApiCalls.getRequestBody({ id: call.id }).$promise;
                        }
                        if (mode === 'upstream') {
                            return ValuationApiCalls.getUpstreamResponseBody({ id: call.id }).$promise;
                        }
                        if (mode === 'upstream-request') {
                            return ValuationApiCalls.getUpstreamRequestBody({ id: call.id }).$promise;
                        }
                        return ValuationApiCalls.getResponseBody({ id: call.id }).$promise;
                    }],
                    call: function() {
                        return call;
                    },
                    mode: function() {
                        return mode;
                    }
                }
            });
        }
    }
})();
